import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import SlowMotionVideoOutlinedIcon from '@mui/icons-material/SlowMotionVideoOutlined';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import { LISTING_FIELD_MODE, getModeLabel } from '../../util/soulwise-marketplace/listingFields';
import { isDigitalProductListingType } from '../../util/soulwise-marketplace/listingType';
import ListingImage from '../ListingImage/ListingImage';
import css from './ListingPreview.module.css';

const ListingPreview = ({ className, listing }) => {
  const classes = classNames(css.root, className);
  const title = listing?.attributes?.title || '';
  const location = listing?.attributes?.publicData?.location;
  const mode = listing?.attributes?.publicData?.mode;
  const config = useConfiguration();

  const listingType = listing?.attributes?.publicData?.listingType;
  const isDigitalListing = isDigitalProductListingType(listingType);
  const isOnline = mode === LISTING_FIELD_MODE.online;
  const onlineModeLabel = getModeLabel(mode, config);
  const locationName = location?.venueName || location?.name || 'Location name';

  return (
    <div className={classes}>
      <div className={css.imageWrapper}>
        <ListingImage listing={listing} rootClassName={css.listingImateRoot} />
      </div>
      <div className={css.infoWrapper}>
        <div className={css.title} title={title}>
          {title}
        </div>
        {!isDigitalListing ? (
          <div className={css.location} title={locationName}>
            {isOnline ? (
              <span className={css.locationIcon} aria-label="Online">
                <SlowMotionVideoOutlinedIcon fontSize="16px" />
              </span>
            ) : (
              <span className={css.locationIcon} aria-label="Location">
                <FmdGoodOutlinedIcon fontSize="16px" />
              </span>
            )}
            <span>{isOnline ? onlineModeLabel : locationName}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

ListingPreview.propTypes = {
  className: PropTypes.string,
  listing: PropTypes.object.isRequired,
};

export default ListingPreview;
